import { render, staticRenderFns } from "./CommissionersSalePropertyList.vue?vue&type=template&id=2f0d2eab&"
import script from "./CommissionersSalePropertyList.vue?vue&type=script&lang=js&"
export * from "./CommissionersSalePropertyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports